<template>
  <div v-loading="loading">
    <div class="header">
      <el-button
        type="primary"
        @click="$router.push({ name: 'RegulatoryDocumentsAdd' })"
        >Qo'shish</el-button
      >
    </div>
    <el-table
      class="table-body"
      :data="tableData"
      border
      height="calc(100vh - 250px)"
    >
      <el-table-column type="index" label="T/r" />
      <el-table-column prop="title" label="Nomi" />
      <el-table-column
        align="center"
        prop="images"
        class="img-column"
        label="Fayl"
      >
        <template #default="scope">
          <img
            v-if="scope.row.images[0]?.file_id"
            :src="baseUrl + scope.row.images[0]?.file_id"
            alt="Image"
          />
        </template>
      </el-table-column>
      <el-table-column align="center">
        <template #default="scope">
          <el-button
            size="small"
            type="danger"
            @click="deleteRegulatoryDoc(scope.row.id)"
            >O'chirish
          </el-button>
          <el-button
            size="small"
            type="primary"
            @click="
              $router.push({
                name: 'RegulatoryDocumentsEdit',
                params: { id: scope.row.id },
              })
            "
            >Tahrirlash
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <div>Umumiy soni: {{ totalCount }}</div>
      <el-pagination
        background
        layout="sizes, prev, pager, next"
        :total="totalCount"
        v-model:page-size="limit"
        v-model:current-page="currentPage"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import { ElMessage, ElMessageBox, ElNotification } from "element-plus";
export default {
  name: "RegulatoryDocuments",
  data() {
    return {
      loading: false,
      tableData: [],
      currentPage: 1,
      limit: 20,
      totalCount: 0,
      baseUrl: process.env.VUE_APP_BASE_API_URL + "/api/v2/info/file/",
    };
  },
  methods: {
    getRegulatoryDoc() {
      this.loading = true;
      this.$http
        .get(`api/v1/posts/legislation`, {
          params: {
            limit: this.limit,
            offset: this.limit * (this.currentPage - 1),
          },
        })
        .then(({ data }) => {
          this.tableData = data.results;
          this.totalCount = data.count;
        })
        .catch(({ response }) => {
          ElNotification.error({
            message:
              response.data.message ||
              "Ma'lumot yuklashda xatolik sodir bo'ldi!",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },

    deleteRegulatoryDoc(id) {
      ElMessageBox.confirm("Normativ hujjatni o'chirasizmi?", "Diqqat!", {
        confirmButtonText: "Ha",
        cancelButtonText: "Bekor qilish",
        type: "warning",
      })
        .then(() => {
          this.loading = true;
          this.$http
            .delete(`api/v1//posts/legislation/${id}`)
            .then(() => {
              ElMessage({
                type: "success",
                message: "Muvaffaqqiyatli o'chirildi",
              });
              this.getRegulatoryDoc();
            })
            .catch(() => {
              ElNotification({
                type: "error",
                title: "Xatolik",
                message: "Iltimos, qayta urinib ko'ring",
              });
            })
            .finally(() => {
              this.loading = false;
            });
        })
        .catch(() => {
          ElMessage({
            type: "info",
            message: "O'chirish bekor qilindi",
          });
        });
    },

    handleCurrentChange() {
      this.$router.replace({
        query: { ...this.$route.query, page: this.currentPage },
      });
      this.getRegulatoryDoc();
    },
    handleSizeChange() {
      this.$router.replace({
        query: { ...this.$route.query, size: this.limit, page: 1 },
      });
      this.currentPage = 1;
      this.getRegulatoryDoc();
    },
  },
  mounted() {
    this.getRegulatoryDoc();
    if (this.$route.query.size) {
      this.limit = parseInt(this.$route.query.size);
    }
    if (this.$route.query.page) {
      this.currentPage = parseInt(this.$route.query.page);
    }
  },
};
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
  gap: 10px;
}
.table-body {
  img {
    width: 80px;
  }
}

.pagination {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  margin-top: 10px;
}
</style>
